import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://a375fb1b5147d554338486abacc5053d@o4507541199257600.ingest.us.sentry.io/4507541216690176",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});